import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rt-lines-rating',
  templateUrl: 'lines-rating.component.html',
  styleUrls: ['./lines-rating.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinesRatingComponent implements OnInit {
  @Input() public rating: number;

  public lines: boolean[] = [];

  private ratings: string[] = [
    'rtu.common.rating.poor',
    'rtu.common.rating.potential',
    'rtu.common.rating.good',
    'rtu.common.rating.very_good',
    'rtu.common.rating.excellent',
  ];

  public ngOnInit(): void {
    const rating = Math.ceil(this.rating) - 1;

    this.lines = this.ratings.map((_, index) => index <= rating);
  }

  public getRatingString(): string {
    return this.ratings[Math.ceil(this.rating) - 1];
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
